import { RoomType } from 'types/enums';

export const wherebyVisibility = (roomType?: RoomType, roomMeetLink?: string): boolean =>
  Boolean(roomMeetLink && roomType !== RoomType.Individual && roomType !== RoomType.Demo);
